import React from 'react';

function About() {
  return <div id="vue3AppContainer" />;
}

export default About;
